var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage-tab stage-tab--default"},[_c('div',{staticClass:"content-top"}),_c('div',{staticClass:"content-center"},[(_vm.stages.length)?_c('StageList',{attrs:{"stageList":_vm.stages}}):_c('div',{staticClass:"no-plan"},[_vm._v("Нет плана согласования")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }